import { roles } from 'src/config/roles-config.js';

export const features = {
  path_finder: 'PATH_FINDER_SUBSCRIPTION',
  value_story: 'VALUE_STORY',
};

export const featureLabels = {
  [features.path_finder]: 'Pathfinder',
  [features.value_story]: 'Value Story',
};

// What each feature unlocks in the portal, shown on the admin Feature Control
// page. Only features the portal code actually checks for are listed.
export const featureDescriptions = {
  [features.path_finder]: 'Unlocks the Pathfinder page.',
  [features.value_story]:
    'Shows the Value Story tab and page, the cost-avoided figures on the home dashboard, and the Value Story option on Define Operation.',
  'SHOW STEP IMAGES':
    'Adds the "show step images" switch to a device\'s controls on the Devices page.',
  SHOW_TASK_DEFINITION:
    'Adds the "show task definition" switch to a device\'s controls on the Devices page.',
  FPS_THROTTLING:
    'Adds the FPS cap setting to a device\'s controls on the Devices page.',
};

// Roles that always get a feature, even when the org is not subscribed to it.
export const featureBypassRoles = {
  [features.value_story]: [roles.support_user, roles.admin],
};

export function isFeatureBypassRole(featureName, role) {
  return Boolean(featureBypassRoles[featureName]?.includes(role));
}

// Single source of truth for feature gating; used by the sidebar getter and
// the router guard so they cannot disagree.
export function hasFeatureAccess(featureName, role, featureSubscriptions) {
  if (isFeatureBypassRole(featureName, role)) return true;
  return Boolean(
    featureSubscriptions?.some(
      (item) =>
        item?.Feature?.name === featureName && !item?.Feature?.suppressed
    )
  );
}
